const routes = {
  '/': '',
  '/formularios': 'Listado de formulario',
  '/registros': 'Listado de registros',
  '/locales': 'Listado de locales',
  '/usuarios': 'Listado de usuarios',
  '/cuenta': 'Información de usuario',
  '/login' : 'Login'
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js